import * as Styles from "layouts/PrivateLayout.styles"
import { Typography } from "@mui/material"
import { Link } from "react-router-dom"
import { IBookingSlot } from "services/bookingSlots"


const BookingDetailsOrderData: React.FC<IBookingSlot | any> = ({ booking }) => {
    const order = booking?.order
    
    return <>
        <Styles.FlexContainer flex-col>
            <Styles.FlexContainerColumn className="pr-16">
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    Order Number: <Link to={`/admin/orders/${order?.id}`} className="text-blue-500">#{ order?.order_number }</Link>
                </Typography>
            </Styles.FlexContainerColumn>
        </Styles.FlexContainer>
    </>
    
}

export default BookingDetailsOrderData